/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PaginatedPaymentList,
    PaginatedPaymentListFromJSON,
    PaginatedPaymentListToJSON,
    PatchedBulkAssignDeals,
    PatchedBulkAssignDealsFromJSON,
    PatchedBulkAssignDealsToJSON,
    PatchedPaymentUpdate,
    PatchedPaymentUpdateFromJSON,
    PatchedPaymentUpdateToJSON,
    PaymentBulk,
    PaymentBulkFromJSON,
    PaymentBulkToJSON,
    PaymentUpdate,
    PaymentUpdateFromJSON,
    PaymentUpdateToJSON,
} from '../models';

export interface BulkAssignDealsRequest {
    patchedBulkAssignDeals?: PatchedBulkAssignDeals;
}

export interface BulkCreatePaymentsRequest {
    paymentBulk: PaymentBulk;
}

export interface ExportPaymentsRequest {
    dateFrom?: Date;
    dateTo?: Date;
    deal?: number;
    paymentType?: ExportPaymentsPaymentTypeEnum;
    unpaired?: boolean;
}

export interface ListPaymentsRequest {
    category?: Array<ListPaymentsCategoryEnum>;
    dateFrom?: Date;
    dateTo?: Date;
    deal?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
    paymentType?: ListPaymentsPaymentTypeEnum;
    search?: string;
    unpaired?: boolean;
}

export interface PartialUpdatePaymentRequest {
    id: number;
    patchedPaymentUpdate?: PatchedPaymentUpdate;
}

export interface UpdatePaymentRequest {
    id: number;
    paymentUpdate?: PaymentUpdate;
}

/**
 * PaymentsApi - interface
 * 
 * @export
 * @interface PaymentsApiInterface
 */
export interface PaymentsApiInterface {
    /**
     * 
     * @param {PatchedBulkAssignDeals} [patchedBulkAssignDeals] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    bulkAssignDealsRaw(requestParameters: BulkAssignDealsRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    bulkAssignDeals(requestParameters: BulkAssignDealsRequest): Promise<void>;

    /**
     * 
     * @param {PaymentBulk} paymentBulk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    bulkCreatePaymentsRaw(requestParameters: BulkCreatePaymentsRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    bulkCreatePayments(requestParameters: BulkCreatePaymentsRequest): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    downloadPaymentsRaw(): Promise<runtime.ApiResponse<void>>;

    /**
     */
    downloadPayments(): Promise<void>;

    /**
     * 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {number} [deal] 
     * @param {'INCOMING_PAYMENT' | 'OUTGOING_PAYMENT'} [paymentType] 
     * @param {boolean} [unpaired] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    exportPaymentsRaw(requestParameters: ExportPaymentsRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     */
    exportPayments(requestParameters: ExportPaymentsRequest): Promise<Blob>;

    /**
     * 
     * @param {Array<'BOND_JAMES' | 'HARD_COLLECTION' | 'INTEREST_PAYMENT_REFUND' | 'INTERNAL_BORROWING' | 'INTERNAL_INSTALLMENT' | 'INVESTOR_LOAN' | 'INVOICES' | 'MEDIATION_COMMISSION' | 'OPERATION_PAYMENTS' | 'OTHERS' | 'PURPOSE' | 'SUBLEASE_DEPOSIT' | 'TAX_OFFICE' | 'TRANSFER_INTERNAL_ACCOUNTS' | 'UNCATEGORIZED' | 'YIELD'>} [category] 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {string} [deal] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {'INCOMING_PAYMENT' | 'OUTGOING_PAYMENT'} [paymentType] 
     * @param {string} [search] 
     * @param {boolean} [unpaired] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    listPaymentsRaw(requestParameters: ListPaymentsRequest): Promise<runtime.ApiResponse<PaginatedPaymentList>>;

    /**
     */
    listPayments(requestParameters: ListPaymentsRequest): Promise<PaginatedPaymentList>;

    /**
     * 
     * @param {number} id A unique integer value identifying this payment.
     * @param {PatchedPaymentUpdate} [patchedPaymentUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    partialUpdatePaymentRaw(requestParameters: PartialUpdatePaymentRequest): Promise<runtime.ApiResponse<PaymentUpdate>>;

    /**
     */
    partialUpdatePayment(requestParameters: PartialUpdatePaymentRequest): Promise<PaymentUpdate>;

    /**
     * 
     * @param {number} id A unique integer value identifying this payment.
     * @param {PaymentUpdate} [paymentUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApiInterface
     */
    updatePaymentRaw(requestParameters: UpdatePaymentRequest): Promise<runtime.ApiResponse<PaymentUpdate>>;

    /**
     */
    updatePayment(requestParameters: UpdatePaymentRequest): Promise<PaymentUpdate>;

}

/**
 * 
 */
export class PaymentsApi extends runtime.BaseAPI implements PaymentsApiInterface {

    /**
     */
    async bulkAssignDealsRaw(requestParameters: BulkAssignDealsRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/payments/bulk_assign_deals/`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedBulkAssignDealsToJSON(requestParameters.patchedBulkAssignDeals),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async bulkAssignDeals(requestParameters: BulkAssignDealsRequest): Promise<void> {
        await this.bulkAssignDealsRaw(requestParameters);
    }

    /**
     */
    async bulkCreatePaymentsRaw(requestParameters: BulkCreatePaymentsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.paymentBulk === null || requestParameters.paymentBulk === undefined) {
            throw new runtime.RequiredError('paymentBulk','Required parameter requestParameters.paymentBulk was null or undefined when calling bulkCreatePayments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/payments/bulk_create_payments/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentBulkToJSON(requestParameters.paymentBulk),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async bulkCreatePayments(requestParameters: BulkCreatePaymentsRequest): Promise<void> {
        await this.bulkCreatePaymentsRaw(requestParameters);
    }

    /**
     */
    async downloadPaymentsRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/payments/download/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async downloadPayments(): Promise<void> {
        await this.downloadPaymentsRaw();
    }

    /**
     */
    async exportPaymentsRaw(requestParameters: ExportPaymentsRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['date_from'] = (requestParameters.dateFrom as any).toISOString().substr(0,10);
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['date_to'] = (requestParameters.dateTo as any).toISOString().substr(0,10);
        }

        if (requestParameters.deal !== undefined) {
            queryParameters['deal'] = requestParameters.deal;
        }

        if (requestParameters.paymentType !== undefined) {
            queryParameters['payment_type'] = requestParameters.paymentType;
        }

        if (requestParameters.unpaired !== undefined) {
            queryParameters['unpaired'] = requestParameters.unpaired;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/payments/export/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async exportPayments(requestParameters: ExportPaymentsRequest): Promise<Blob> {
        const response = await this.exportPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listPaymentsRaw(requestParameters: ListPaymentsRequest): Promise<runtime.ApiResponse<PaginatedPaymentList>> {
        const queryParameters: any = {};

        if (requestParameters.category) {
            queryParameters['category'] = requestParameters.category;
        }

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['date_from'] = (requestParameters.dateFrom as any).toISOString().substr(0,10);
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['date_to'] = (requestParameters.dateTo as any).toISOString().substr(0,10);
        }

        if (requestParameters.deal !== undefined) {
            queryParameters['deal'] = requestParameters.deal;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.paymentType !== undefined) {
            queryParameters['payment_type'] = requestParameters.paymentType;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.unpaired !== undefined) {
            queryParameters['unpaired'] = requestParameters.unpaired;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/payments/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPaymentListFromJSON(jsonValue));
    }

    /**
     */
    async listPayments(requestParameters: ListPaymentsRequest): Promise<PaginatedPaymentList> {
        const response = await this.listPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdatePaymentRaw(requestParameters: PartialUpdatePaymentRequest): Promise<runtime.ApiResponse<PaymentUpdate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdatePayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/payments/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedPaymentUpdateToJSON(requestParameters.patchedPaymentUpdate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentUpdateFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdatePayment(requestParameters: PartialUpdatePaymentRequest): Promise<PaymentUpdate> {
        const response = await this.partialUpdatePaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updatePaymentRaw(requestParameters: UpdatePaymentRequest): Promise<runtime.ApiResponse<PaymentUpdate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/payments/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentUpdateToJSON(requestParameters.paymentUpdate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentUpdateFromJSON(jsonValue));
    }

    /**
     */
    async updatePayment(requestParameters: UpdatePaymentRequest): Promise<PaymentUpdate> {
        const response = await this.updatePaymentRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ExportPaymentsPaymentTypeEnum {
    IncomingPayment = 'INCOMING_PAYMENT',
    OutgoingPayment = 'OUTGOING_PAYMENT'
}
/**
    * @export
    * @enum {string}
    */
export enum ListPaymentsCategoryEnum {
    BondJames = 'BOND_JAMES',
    HardCollection = 'HARD_COLLECTION',
    InterestPaymentRefund = 'INTEREST_PAYMENT_REFUND',
    InternalBorrowing = 'INTERNAL_BORROWING',
    InternalInstallment = 'INTERNAL_INSTALLMENT',
    InvestorLoan = 'INVESTOR_LOAN',
    Invoices = 'INVOICES',
    MediationCommission = 'MEDIATION_COMMISSION',
    OperationPayments = 'OPERATION_PAYMENTS',
    Others = 'OTHERS',
    Purpose = 'PURPOSE',
    SubleaseDeposit = 'SUBLEASE_DEPOSIT',
    TaxOffice = 'TAX_OFFICE',
    TransferInternalAccounts = 'TRANSFER_INTERNAL_ACCOUNTS',
    Uncategorized = 'UNCATEGORIZED',
    Yield = 'YIELD'
}
/**
    * @export
    * @enum {string}
    */
export enum ListPaymentsPaymentTypeEnum {
    IncomingPayment = 'INCOMING_PAYMENT',
    OutgoingPayment = 'OUTGOING_PAYMENT'
}
